export default __webpack_public_path__ + "static/AboutUs-da58c5bb09df01fb8eefa04f73d1a1c2.png";